import React, { useState, useContext, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import Tool_tabs from '../../Components/Tools/Tool_tabs';
import { FormattedMessage } from 'react-intl';
import { CusButton } from '../../Components/From/Button';
import { StaffFrom } from '../From/StaffFrom';
import { CusRadio } from '../From/Radio';
import { Input } from 'reactstrap';
import { CusInput } from '../../Components/From/Input';
import { CusCheckboxOne } from '../../Components/From/CheckboxOne';
import cls from 'classnames';
import { Global } from '../../App';
import QrReader from 'react-qr-reader';
import moment from 'moment';
import {
  isIOS,
  isAndroid,
  isSafari,
  isChrome,
  isFirefox,
  browserName,
  browserVersion
} from 'react-device-detect';

// switch lang
import { langStringToCode,langCodeToString } from '../../Share/Tools/switchLang';

// api test
import { getOrderInfo} from '../../Api/staff/GetOrderInfo';
import { getTranslationStaffInfo } from '../../Api/staff/GetStaffInfo';
import { postCreateOrder } from '../../Api/GetOrder';
import {
  postManualVerifyQueue,
  postQRCodeVerifyQueue
} from '../../Api/VerifyQueue';

import Tool_storeName from '../Tools/Tool_storeName';
import { useCallback } from 'react';
import qs from 'querystring'
/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 * 1-1
 * currentCheckOrderStep => '2 ± 1'
 * checkOrderBranch
 * checkOrderGroup
 * checkOrderStaff
 * checkOrderData => api (order data)
 *
 *
 */
function StaffCheckStep_2({
  code,
  onClearCode,
  onError,
  ...props
}) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    selectedTab: '',
    useQRCode: false,
    orderCode: '',
    Tableno: '',
    TableNoOf: 1,
    Posno: '',
    bTableno: true,
    bPosno: false,
    bOrderCode: false
  });

  const clickBtn = useRef(null);
  function handleClick() {
    clickBtn.current.click()
  }

  const isScan = useRef(true);
  const date = new Date();
  let Month = (date.getMonth() + 1).toString();
  let day = (date.getDate()).toString();

  if (Month.length === 1) {
    Month = `0${Month}`
  }

  if (day.length === 1) {
    day = `0${day}`;
  }

  const PosNo = `${date.getFullYear()}${Month}${day}`;
  let pcStyle = globalState.device === 'pc';
  const verifyItems = [
    {
      title: <FormattedMessage id="pages.staffCheckOrder.step2.tabs.qr" />,
      info: 'qr',
      className: 'staff-check-step2-use-qr'
    },
    {
      title: <FormattedMessage id="pages.staffCheckOrder.search" />,
      info: 'code',
      className: 'staff-check-step2-use-code'
    }
  ];

  const apiOrderInfo = useCallback(async (orderCode, langType, StaffCode, Posno, Tableno, TableNoOf) => {
    const langId = langStringToCode(globalState.langType);
    const waiterID = globalState.staffInfo.checkOrderStaff.staffCode;
    const storeID = globalState.staffInfo.checkOrderBranch.branchCode;
    const createAt = moment(new Date()).format('YYYY/MM/DD');
    let TableNo = Tableno ? Tableno + "-" + TableNoOf : "";
    let PosNo = Posno;

    if (PosNo) {
      // 補齊4碼
      while (PosNo.length < 4) {
        PosNo = `0${PosNo}`;
      }

      PosNo = `${moment(new Date()).format('YYYYMMDD')}${PosNo}`
    }

    try {
      const res = await getOrderInfo(orderCode, langId, waiterID, storeID, createAt, PosNo, TableNo);
      //const res = await getOrderInfoData(orderCode, langId, waiterID, storeID, createAt, PosNo, TableNo);
      const { errCode, productList: orderInfo } = res.data;
      console.log("res.data",res.data)
      if (errCode === 200) {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: "langType",
              val: langCodeToString(orderInfo.originOrderLanguageID),
            },
            {
              key: 'staffInfo.orderCode',
              val: orderCode
            },
            {
              key: 'staffInfo.createAt',
              val: createAt
            },
            {
              key: 'staffInfo.Posno',
              val: PosNo
            },
            {
              key: 'staffInfo.Tableno',
              val: Tableno
            },
            {
              key: 'staffInfo.TableNoOf',
              val: TableNoOf
            }, {
              key: 'staffInfo.currentCheckOrderStep',
              val: '3'
            }, {
              key: 'staffInfo.prevPath',
              val: '/staffCheckOrder'
            }, {
              key: 'staffInfo.changeOrderLang',
              val: false
            }, {
              key: 'staffInfo.checkOrderData',
              val: {
                state: orderInfo.status,
                dineIn: orderInfo.dineIn,
                takeout: orderInfo.takeout,
                isAddOrder: orderInfo.isAddOrder,
                posTableNo: orderInfo.posTableNo,
                mainOrderCode: orderInfo.mainOrderCode,
                orderCode: orderInfo.orderCode,
                mainOrderID: orderInfo.mainOrderID,
                numberOfAdult: orderInfo.adultsCount,
                numberOfChild: orderInfo.childCount,
                orderType: orderInfo.orderType,
                country: {
                  countryId: orderInfo.countryID,
                  countryName: orderInfo.countryName
                },
                queueNumber: orderInfo.queueNumber,
                queueCode: orderInfo.queueCode,
                orderTime: orderInfo.createAt,
                branch: {
                  branchCode: orderInfo.storeID,
                  branchName: orderInfo.storeName
                },
                remark: orderInfo.remark
              }
            }
          ]
        });
      }
      else {
        onError && onError(errCode)
        // console.error('OrderInfo error.');
        // dispatchGlobal({
        //   type: 'UPDATE',
        //   payload: [{ key: 'errMsg', val: errCode }]
        // });
        // props.history.push('/staff/error');
      }
    } catch (err) {
      onError && onError(413)
      // console.error('OrderInfo error.');
      // dispatchGlobal({
      //   type: 'UPDATE',
      //   payload: [{ key: 'errMsg', val: 413 }]
      // });
      // props.history.push('/staff/error');
    }
  }, [
    globalState.langType,
    globalState.staffInfo.checkOrderStaff.staffCode,
    onError
  ])

  async function apiTranslationStaffInfo(staffId, storeId, LangId) {
    try {
      const res = await getTranslationStaffInfo(staffId, storeId, LangId);
      const { errCode, response } = res.data;
      if (errCode == 200) {
        return response;
      } else {
        console.error('TranslationStaffInfo error.', errCode);
      }
    } catch (err) {
      console.error('TranslationStaffInfo error.');
    }
  }

  async function apiVerifyQRCode(par) {
    try {
      const res = await postQRCodeVerifyQueue({
        queueNumber: par.queueNumber,
        queueCode: par.queueCode,
        storeID: par.storeID
      });
      const { errCode } = res.data;
      if (res && errCode == 200) {
        return res;
        // 已建單
      } else if (res && errCode == 420) {
        const { orderCode, storeID, createAt } = res.data.response;
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo',
              val: {
                ...globalState.staffInfo,
                orderCode,
                createAt,
                checkOrderBranch: {
                  ...globalState.staffInfo.checkOrderBranch,
                  branchCode: storeID
                }
              }
            }
          ]
        });
        props.history.replace('/staffOrderDetail');
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      console.error('QRCodeVerifyQueue error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 405 }]
      });
      props.history.push('/staff/error');
    }
  }

  // 驗證排隊號碼 & 取號驗證碼
  async function apiManualVerifyQueue(requireData) {
    try {
      const res = await postManualVerifyQueue(requireData);
      const { errCode } = res.data;
      // 驗證通過
      if (res) {
        let {
          verify,
          childCount,
          adultsCount,
          countryID,
          countryName,
          storeID,
          storeName,
          orderCode,
          createAt
        } = res.data.response;
        if (orderCode !== null) {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [
              {
                key: 'staffInfo',
                val: {
                  ...globalState.staffInfo,
                  orderCode
                }
              }
            ]
          });
          props.history.replace('/staffOrderDetail');
        } else {
          try {
            let res = await postCreateOrder({
              queueNumber: requireData.queueNumber,
              queueCode: requireData.queueCode,
              countryID: countryID,
              storeID: globalState.staffInfo.checkOrderBranch.branchCode,
              adultsCount: adultsCount,
              childCount: childCount,
              languageID: langStringToCode(globalState.langType),
              userEmail: '',
              dineIn: [],
              takeout: [],
              totalPrice: 0,
              waiterID: globalState.staffInfo.checkOrderStaff.staffCode
            });
            const { orderCode } = res.data.order;
            const { errCode } = res.data;
            // AsyncModelClose();
            if (errCode === 200) {
              dispatchGlobal({
                type: 'UPDATE',
                payload: [
                  {
                    key: 'staffInfo.prevPath',
                    val: '/staffTakeOrder'
                  }, {
                    key: 'staffInfo',
                    val: {
                      ...globalState.staffInfo,
                      currentTakeOrderStep: '4',
                      orderCode,
                      takeOrderData: {
                        ...globalState.staffInfo.takeOrderData,
                        country: countryID,
                        countryName: countryName,
                        queueNumber: requireData.queueNumber,
                        queueCode: requireData.queueCode,
                        numberOfAdult: adultsCount,
                        numberOfChild: childCount
                      }
                    }
                  }
                ]
              });
             
              props.history.replace('/staffTakeOrder');
            } else {
              dispatchGlobal({
                type: 'UPDATE',
                payload: [{ key: 'errMsg', val: errCode }]
              });
              props.history.push('/staff/error');
            }
          } catch (err) {
            console.error('CreateOrder error.');
            dispatchGlobal({
              type: 'UPDATE',
              payload: [{ key: 'errMsg', val: 409 }]
            });
            props.history.push('/staff/error');
          }
        }
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: res.data.errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      console.error('LangOption error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 405 }]
      });
      props.history.push('/staff/error');
    }
  }

  const onScan = async data => {
    if (!data) return (isScan.current = true);
    if (
      data !== '' &&
      data !== null &&
      data !== undefined &&
      isScan.current
    ) {
      const [url, search] = data.split('?');
      isScan.current = false;
      const isCheckOrder = data.indexOf('staffCheckOrder') > -1,
        isTakeOrder = data.indexOf('QRCodeSuccess') > -1;
      if (isCheckOrder) {
        const { orderCode: code } = qs.parse(search)
        await apiOrderInfo(code);
      } else if (isTakeOrder) {
        const par = qs.parse(search);
        const qrcode = await apiVerifyQRCode(par);
        if (qrcode) {
          apiManualVerifyQueue({
            queueNumber: par.queueNumber,
            queueCode: par.queueCode,
            storeID: qrcode.data.response.storeID,
            languageID: langStringToCode(globalState.langType)
          });
        }
      }
    }
  }

  useEffect(() => {
    if (code !== undefined) {
      apiOrderInfo(code).then(() => {
        onClearCode()
      })
    }
  }, [code, onClearCode, apiOrderInfo])
 
  useEffect(() => {
    let staffCode = globalState.staffInfo.checkOrderStaff.staffCode;
    let storeCode = globalState.staffInfo.checkOrderBranch.branchCode;
    let langCode = langStringToCode(globalState.langType);
    const handler = async () => {
      let translateStaff = await apiTranslationStaffInfo(
        staffCode,
        storeCode,
        langCode
      );
      if (translateStaff) {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo.checkOrderBranch.branchName',
              val: translateStaff.storeName
            }
          ]
        });
      }
    };

    handler();
  }, [
    globalState.langType,
    globalState.staffInfo.checkOrderStaff.staffCode,
    globalState.staffInfo.checkOrderBranch.branchCode,
    dispatchGlobal
  ]);

  // QRcode
  function showQRCode() {
    console.log(browserName, browserVersion);
    if (
      !state.useQRCode || // 沒有選擇QRCode功能
      (isIOS && !isSafari) || // ios系統但瀏覽器非safari
      (isAndroid && !(isChrome || isFirefox)) ||  // android系統但瀏覽器非 chrome || firefox
      code !== undefined
    )
      return null;
    return (
      <>
        <div
          className="Pages__QRCode"
          style={{ width: pcStyle ? '50%' : '80%' }}
        >
          <QrReader
            delay={600}
            onError={err => {
              console.error(err);
            }}
            onScan={onScan}
          />
        </div>
      </>
    );
  }

  // 回選擇人員列表
  function backToStaffList() {
    dispatchGlobal({
      type: 'UPDATE',
      payload: [
        {
          key: 'staffInfo',
          val: {
            ...globalState.staffInfo,
            currentCheckOrderStep: '1',
            checkOrderStaff: ''
          }
        }
      ]
    });
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-center txtColorBrown mb-3">
       
        <span className="m-2">
          <Tool_storeName storeId={globalState.staffInfo.checkOrderBranch.branchCode} />
          {/* {globalState.staffInfo.checkOrderBranch.branchName} */}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderGroup.groupName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffNum}
        </span>
      </div>
    
      {/* 選擇驗證方式 tabs */}
      {(() => {
        // 禁止顯示 tabs
        if (
          (isIOS && !isSafari) || // ios系統但瀏覽器非safari
          (isAndroid && !(isChrome || isFirefox)) // android系統但瀏覽器非 chrome || firefox
        )
          return null;
        return (
          <Tool_tabs
            items={verifyItems}
            selected={state.selectedTab || verifyItems[1]}
            onChangeItems={selectedItem => {
              let useQRCode = selectedItem.info === 'qr';
              setState(curr => {
                return {
                  ...curr,
                  selectedTab: selectedItem,
                  useQRCode: useQRCode
                };
              });
            }}
          />
        );
      })()}
      <div
        className="d-flex col flex-column justify-content-center align-items-center mt-3 mb-3 p-0"
        style={{
          backgroundColor: (() => {
            if (
              (isIOS && !isSafari) ||
              (isIOS && isSafari && !state.useQRCode) ||
              (!isIOS && !state.useQRCode) ||
              (isAndroid && !(isChrome || isFirefox))
            ) {
              return '';
            } else {
              return '#000';
            }
          })()
        }}
      >
        {state.useQRCode && <>{showQRCode()}</>}
        {(() => {
          if (
            (isIOS && !isSafari) ||
            (isIOS && isSafari && !state.useQRCode) ||
            (!isIOS && !state.useQRCode && !(isChrome || isFirefox)) ||
            (isAndroid && !(isChrome || isFirefox)) ||
            !state.useQRCode
          )
            return (
              <div
                className="d-flex flex-column pt-4 pb-4"
                style={{
                  minWidth: pcStyle ? '400px' : '100%',
                  maxWidth: pcStyle ? '400px' : '100%'
                }}
              >
                {/* input */}
                <CusRadio
                  checked={state.bTableno}
                  title={
                    <>
                      <FormattedMessage id="pages.staffCheckOrder.step3.tableNumber" />
                      <div className="d-inline-block">
                        <div style={{ width: '40px' }}>
                          <CusInput
                            className="text-center"
                            value={state.Tableno}
                            maxLength={3}
                            type="tel"
                            onChange={event => {
                              let val = event.target.value;
                              setState(curr => {
                                return {
                                  ...curr,
                                  orderCode: '',
                                  posno: '',
                                  Tableno: val
                                }
                              })
                            }}
                          />
                        </div>
                      </div>
                      <span className="text-nowrap mr-2 ml-2">-</span>
                      <div className="d-inline-block align-middle">
                        <CusCheckboxOne
                          checked={state.TableNoOf === 1}
                          value={1}
                          onChange={(e) => {
                            e.stopPropagation()
                            setState(curr => {
                              return {
                                ...curr,
                                TableNoOf: 1
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="d-inline-block align-middle">
                        <CusCheckboxOne
                          checked={state.TableNoOf === 2}
                          value={2}
                          onChange={(e) => {
                            e.stopPropagation()
                            setState(curr => {
                              return {
                                ...curr,
                                TableNoOf: 2
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="d-inline-block align-middle">
                        <CusCheckboxOne
                          checked={state.TableNoOf === 3}
                          value={3}
                          onChange={(e) => {
                            e.stopPropagation()
                            setState(curr => {
                              return {
                                ...curr,
                                TableNoOf: 3
                              };
                            });
                          }}
                        />
                      </div>
                    </>
                  }
                  onChange={(e) => {
                    setState(curr => {
                      return {
                        ...curr,
                        bTableno: true,
                        bPosno: false,
                        bOrderCode: false,
                        orderCode: '',
                        posno: '',
                        Tableno: ""
                      }
                    })
                  }}
                />
                <p className='ml-9 text-sm text-rose-800'>{globalState.langFile['pages.staffCheckOrder.addorderNotice']}</p>
                <FormattedMessage
                  id="pages.staffCheckOrder.step2.orderCodeInputPlaceholder"
                  children={msg => {
                    return (
                      <>
                        <StaffFrom
                          title={PosNo}
                          state={state.bPosno}
                          className="inline uppercase"
                          label={
                            <FormattedMessage id="pages.staffOrderDetail.orderInfo.posNumber" />
                          }
                          memo={
                            `${globalState.langFile['pages.staffCheckOrder.addorderPosNotice']}`
                          }
                          maxLength='4'
                          value={state.posno || ''}
                          /*placeholder={msg}*/
                          onKeyPress={(ev) => {
                            if (ev.key === 'Enter') {
                              handleClick()
                            }
                          }}
                          onChange={event => {
                            let val = event.target.value;
                            if (val) {
                              val = event.target.value.trim().toUpperCase();
                            }
                            if (val === "ON") {
                              val = "";
                            }
                            setState(curr => {
                              return {
                                ...curr,
                                orderCode: '',
                                Tableno: '',
                                posno: val,
                                bTableno: false,
                                bPosno: true,
                                bOrderCode: false
                              };
                            });
                          }}
                        />
                        <StaffFrom
                          state={state.bOrderCode}
                          className="inline uppercase"
                          label={
                            <FormattedMessage id="pages.staffSearchOrder.orderCode" />
                          }
                          maxLength='6'
                          value={state.orderCode || ''}
                          /*placeholder={msg}*/
                          onKeyPress={(ev) => {
                            if (ev.key === 'Enter') {
                              handleClick()
                            }
                          }}
                          onChange={event => {
                            let val = event.target.value;
                            if (val) {
                              val = event.target.value.trim().toUpperCase();
                            }
                            if (val === "ON") {
                              val = "";
                            }
                            setState(curr => {
                              return {
                                ...curr,
                                orderCode: val,
                                Tableno: '',
                                posno: '',
                                bTableno: false,
                                bPosno: false,
                                bOrderCode: true
                              };
                            });
                          }}
                        />
                      </>
                    );
                  }}
                />
                {/* button */}
                <div className="mt-5 mb-5 mt-sm-5 mb-sm-5 w-100 d-flex">
                  <CusButton.White
                    className="mt-2 mb-2 col p-3 staff-check-step2-code-back"
                    children={
                      <FormattedMessage id="pages.staffCheckOrder.step2.buttonBack" />
                    }
                    onClick={backToStaffList}
                  />
                  {console.log("state",state)}
                  <CusButton.Red
                    className="mt-2 mb-2 ml-3 col p-3 staff-check-step2-confirm"
                    disabled={!state.orderCode && !state.Tableno && !state.posno}
                    children={
                      <FormattedMessage id="pages.staffCheckOrder.step2.buttonConfirm" />
                    }
                    innerRef={clickBtn}
                    onClick={async () => {
                      const { langType, staffInfo } = globalState;
                      await apiOrderInfo(
                        state.orderCode,
                        langStringToCode(langType),
                        staffInfo.checkOrderStaff.staffCode,
                        state.posno,
                        state.Tableno,
                        state.TableNoOf
                      );
                    }}
                  />
                </div>
              </div>
            );
        })()}
      </div>
      {/* <div className="d-flex justify-content-center">
        {state.selectedTab.info !== 'code' ? (
          <CusButton.White
            className={`mt-3 mb-3 p-3 pl-5 pr-5 col staff-check-step2-qr-back col-sm-auto${state.currBranch && state.currShow === 'selectGroup' ?
              ' staff-check-step2-group-back' : state.currBranch && state.currGroup && state.currShow === 'selectStaff' ?
                ' staff-check-step2-staff-back' : ''}`}
            children={
              <FormattedMessage id="pages.staffCheckOrder.step2.buttonBack" />
            }
            onClick={backToStaffList}
          />
        ) : null}
      </div> */}
    </>
  );
}

export default withRouter(StaffCheckStep_2);
